var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-fields" },
    [
      _vm.formParameters
        ? [
            _vm._l(_vm.formParameters, function(parameter, index) {
              var _obj
              return [
                _vm.showField(parameter)
                  ? _c(
                      "v-layout",
                      {
                        key: index,
                        staticClass: "field-row",
                        style: { "padding-left": _vm.level * 5 + "px" },
                        attrs: { row: "" }
                      },
                      [
                        _c(
                          "v-flex",
                          _vm._b(
                            {},
                            "v-flex",
                            ((_obj = {}),
                            (_obj[
                              parameter.type ===
                              _vm.constants.filterTypes.wrapper
                                ? "sm12"
                                : "sm11"
                            ] = true),
                            _obj),
                            false
                          ),
                          [
                            parameter.isEnum || parameter.items
                              ? _c("v-autocomplete", {
                                  ref: "field" + index,
                                  refInFor: true,
                                  staticClass:
                                    "field-input no-input-details form-fields-autocomplete",
                                  class: {
                                    "multi-select": parameter.multiSelect
                                  },
                                  attrs: {
                                    required: parameter.required,
                                    items: _vm.getSelectableItems(parameter),
                                    "item-text": "itemText",
                                    "item-value": "itemValue",
                                    label: _vm.buildLabel(parameter),
                                    title: _vm.buildLabel(parameter),
                                    clearable: !parameter.notClearable,
                                    autocomplete: "",
                                    "search-input": parameter.searchInput,
                                    multiple: parameter.multiSelect,
                                    "menu-props": {
                                      contentClass:
                                        "form-fields-autocomplete-menu"
                                    },
                                    chips: parameter.multiSelect,
                                    "deletable-chips": ""
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.multiSelectChanged({
                                        index: index,
                                        value: $event,
                                        parameter: parameter
                                      })
                                    },
                                    "update:searchInput": function($event) {
                                      return _vm.$set(
                                        parameter,
                                        "searchInput",
                                        $event
                                      )
                                    },
                                    "update:search-input": function($event) {
                                      return _vm.$set(
                                        parameter,
                                        "searchInput",
                                        $event
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.formParameters[index].value,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formParameters[index],
                                        "value",
                                        $$v
                                      )
                                    },
                                    expression: "formParameters[index].value"
                                  }
                                })
                              : parameter.type ===
                                _vm.constants.filterTypes.text
                              ? _c("v-text-field", {
                                  ref: "field" + index,
                                  refInFor: true,
                                  staticClass: "field-input no-input-details",
                                  attrs: {
                                    type: parameter.inputType,
                                    step: parameter.inputTypeStep,
                                    min: parameter.min,
                                    max: parameter.max,
                                    label: _vm.buildLabel(parameter),
                                    title: _vm.buildLabel(parameter),
                                    required: parameter.required
                                  },
                                  on: {
                                    keyup: function($event) {
                                      return _vm.debounceTextFieldChange(index)
                                    }
                                  },
                                  model: {
                                    value: _vm.formParameters[index].value,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formParameters[index],
                                        "value",
                                        $$v
                                      )
                                    },
                                    expression: "formParameters[index].value"
                                  }
                                })
                              : parameter.type ===
                                _vm.constants.filterTypes.random
                              ? _c(
                                  "v-text-field",
                                  {
                                    ref: "field" + index,
                                    refInFor: true,
                                    staticClass:
                                      "field-input random-input no-input-details",
                                    attrs: {
                                      readonly: "",
                                      type: parameter.inputType,
                                      step: parameter.inputTypeStep,
                                      label: _vm.buildLabel(parameter),
                                      title: _vm.buildLabel(parameter),
                                      required: parameter.required
                                    },
                                    model: {
                                      value: _vm.formParameters[index].value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formParameters[index],
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression: "formParameters[index].value"
                                    }
                                  },
                                  [
                                    _c(
                                      "template",
                                      { slot: "append" },
                                      [
                                        _c(
                                          "v-icon",
                                          {
                                            staticClass: "generate-random",
                                            staticStyle: { cursor: "pointer" },
                                            on: {
                                              click: function($event) {
                                                return _vm.setNewRandomValue(
                                                  index
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v("autorenew")]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  2
                                )
                              : parameter.type ===
                                _vm.constants.filterTypes.steps
                              ? [
                                  _c("slider-combo", {
                                    attrs: {
                                      filter: _vm.comboFilterParameter(index),
                                      label: _vm.buildLabel(parameter)
                                    },
                                    on: {
                                      change: function(newVal) {
                                        return _vm.sliderComboUpdated(
                                          index,
                                          newVal
                                        )
                                      }
                                    }
                                  })
                                ]
                              : parameter.type ===
                                _vm.constants.filterTypes.boolean
                              ? [
                                  _c("v-checkbox", {
                                    staticClass:
                                      "pt-0 top-0 form-fields-checkbox",
                                    attrs: { label: _vm.buildLabel(parameter) },
                                    on: {
                                      change: function($event) {
                                        return _vm.fieldUpdated({
                                          index: index,
                                          parameter: parameter
                                        })
                                      }
                                    },
                                    model: {
                                      value: _vm.formParameters[index].value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formParameters[index],
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression: "formParameters[index].value"
                                    }
                                  })
                                ]
                              : parameter.type ===
                                _vm.constants.filterTypes.switch
                              ? _c("v-switch", {
                                  staticClass: "form-switch",
                                  attrs: { label: _vm.buildLabel(parameter) },
                                  on: {
                                    change: function($event) {
                                      return _vm.fieldUpdated({
                                        index: index,
                                        parameter: parameter
                                      })
                                    }
                                  },
                                  model: {
                                    value: _vm.formParameters[index].value,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formParameters[index],
                                        "value",
                                        $$v
                                      )
                                    },
                                    expression: "formParameters[index].value"
                                  }
                                })
                              : parameter.type ===
                                _vm.constants.filterTypes.wrapper
                              ? _c(
                                  "v-expansion-panel",
                                  {
                                    staticClass: "fields-panel",
                                    attrs: {
                                      value: _vm.showPanelExpanded(parameter)
                                    }
                                  },
                                  [
                                    _c(
                                      "v-expansion-panel-content",
                                      {
                                        staticStyle: {
                                          background: "transparent"
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            attrs: { slot: "header" },
                                            slot: "header"
                                          },
                                          [
                                            _c("h4", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.buildLabel(parameter)
                                                )
                                              )
                                            ])
                                          ]
                                        ),
                                        _vm._v(" "),
                                        [
                                          _c("form-fields", {
                                            attrs: {
                                              level: _vm.level + 1,
                                              "parent-index": index,
                                              parameters: parameter.props
                                            },
                                            on: {
                                              fieldUpdated: _vm.fieldUpdated
                                            }
                                          })
                                        ]
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          2
                        ),
                        _vm._v(" "),
                        parameter.type !== _vm.constants.filterTypes.wrapper
                          ? _c(
                              "v-flex",
                              {
                                staticClass: "txt-right top-15",
                                attrs: { sm1: "" }
                              },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "help-btn",
                                    attrs: {
                                      title: _vm.buildDescription(parameter),
                                      flat: "",
                                      icon: ""
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.infoDialog(
                                          _vm.buildLabel(parameter),
                                          _vm.buildDescription(parameter),
                                          { markdown: true, resizable: true }
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("v-icon", { staticClass: "pointer" }, [
                                      _vm._v("help")
                                    ])
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e()
              ]
            })
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-569b6266", { render: render, staticRenderFns: staticRenderFns })
  }
}